export const TripsApiAllowedSchemas = {
  default: 'default',
  invoices: 'invoices',
  itinerary: 'itinerary',
  metadata: 'metadata',
} as const;
